// 6 is chosen because javascript converts to scientific notation at 7, which breaks BE
export const MAX_FRACTION_DIGITS = 6;